import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const GuestIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      viewBox="0 1 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 20.4252V17.1252C4.5 15.7997 5.57452 14.7252 6.9 14.7252H17.1C18.4255 14.7252 19.5 15.7997 19.5 17.1252V20.4252M15.9 7.2252C15.9 9.37911 14.1539 11.1252 12 11.1252C9.84609 11.1252 8.1 9.37911 8.1 7.2252C8.1 5.07128 9.84609 3.3252 12 3.3252C14.1539 3.3252 15.9 5.07128 15.9 7.2252Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
